/** Sizes shown to people use decimal megabytes (1 MB = 1,000,000 bytes), the way macOS Finder and phones report them. */
export const BYTES_PER_MB = 1_000_000;
export function toMB(bytes: number, digits = 1): string {
  return (bytes / BYTES_PER_MB).toFixed(digits);
}
